


















































import { Component, Mixins, Watch } from 'vue-property-decorator'
import { Playlist, PLAYLIST_TYPES } from '@/classes/playlist'
import { HistoryViewMixin, LibraryMixin } from '@/mixins'
import { Track } from '@/classes/track'

enum VIEWS {
  Start = 'start',
  EditTracks = 'edit_tracks'
}

enum ACTIONS {
  Create = 'create',
  Delete = 'delete',
  Copy = 'copy',
  Move = 'move',
  Merge = 'merge',
  Rename = 'rename',
  Sort = 'sort',
  Reorder = 'reorder'
}

@Component({
  components: {
    EditTracks: require('./EditTracks').default,
    PlaylistView: require('./PlaylistView').default,
    ActionCreate: require('./Actions/Create').default,
    ActionDelete: require('./Actions/Delete').default,
    ActionCopy: require('./Actions/Copy').default,
    ActionMove: require('./Actions/Move').default,
    ActionMerge: require('./Actions/Merge').default,
    ActionRename: require('./Actions/Rename').default,
    ActionSort: require('./Actions/Sort').default,
    ActionPrefix: require('./Actions/Prefix').default,
    ActionCrossReference: require('./Actions/CrossReference').default
  }
})
export default class PlaylistEditor extends Mixins(HistoryViewMixin, LibraryMixin) {
  loading: boolean = false
  view: VIEWS = VIEWS.Start
  action: ACTIONS | null = null
  allowDrag: boolean = false

  selectedPlaylists: Playlist[] = []
  tracksFromSelectedPlaylist: Track[] = []

  get selectedPlaylist(): Playlist | null {
    if (this.selectedPlaylists.length === 0) return null

    return this.selectedPlaylists[0]
  }

  get editTracksDisabled(): boolean {
    return this.selectedPlaylists.length !== 1 || this.selectedPlaylists[0].type !== PLAYLIST_TYPES.Playlist
  }

  openActionMove() {
    this.selectedPlaylists = []

    this.action = ACTIONS.Move

    this.allowDrag = true
  }

  closeActionMove() {
    this.action = null

    this.allowDrag = false
  }

  onSave() {
    this.reset()
  }

  reset() {
    this.selectedPlaylists = []
  }

  onEditTracksBack() {
    this.goToView(VIEWS.Start, true)
  }

  onEditTracksSave() {
    // this.onSave()

    // this.back()
  }

  onKeyDown(e: KeyboardEvent) {
    if (e.key === 'Escape') {
      this.reset()
    }
  }

  destroyed() {
    window.removeEventListener('keydown', this.onKeyDown)
  }

  @Watch('selectedPlaylist')
  updateTracksFromSelectedPlaylist() {
    if (this.selectedPlaylists.length === 1 && this.selectedPlaylist) {
      this.tracksFromSelectedPlaylist = this.selectedPlaylist.tracks.map(id => (this.library.tracksObject[id] as Track)) as Track[]
    }
  }

  @Watch('view', { immediate: true })
  watchView() {
    if (this.view === VIEWS.Start) {
      this.reset()

      window.addEventListener('keydown', this.onKeyDown)
    } else {
      window.removeEventListener('keydown', this.onKeyDown)
    }
  }
}
